import React, { ComponentProps } from "react";

export default function CheckmarkIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        d="M4.50007 8.08296L2.76507 6.34796C2.67158 6.25447 2.54479 6.20195 2.41257 6.20195C2.28036 6.20195 2.15356 6.25447 2.06007 6.34796C1.96658 6.44145 1.91406 6.56825 1.91406 6.70046C1.91406 6.76593 1.92696 6.83075 1.95201 6.89123C1.97706 6.95172 2.01378 7.00667 2.06007 7.05296L4.15007 9.14296C4.34507 9.33796 4.66007 9.33796 4.85507 9.14296L10.1451 3.85296C10.2386 3.75947 10.2911 3.63268 10.2911 3.50046C10.2911 3.36825 10.2386 3.24145 10.1451 3.14796C10.0516 3.05447 9.92479 3.00195 9.79257 3.00195C9.66036 3.00195 9.53356 3.05447 9.44007 3.14796L4.50007 8.08296Z"
        fill="black"
      />
    </svg>
  );
}
